import { AxiosResponse } from 'axios'
import { RequestREAD } from 'services/Instances'

export const UnidadeGestoraServices = () => {
  const path = 'UnidadeGestora'

  const getAll = async (): Promise<AxiosResponse<IUnidadeGestoraResponse[]>> =>
    await RequestREAD.get(`${path}`)

  const getById = async (id: number): Promise<AxiosResponse<IUnidadeGestoraResponse>> =>
    await RequestREAD.get(`${path}/${id}`)

  const getByName = async (name: string): Promise<AxiosResponse<IUnidadeGestoraResponse[]>> =>
    await RequestREAD.get(`${path}/getByName/${name}`)

  const autoComplete = async (params: { nmUnidade: string, tipoUnidade: string }): Promise<AxiosResponse<IUnidadeGestoraRelacoes>> =>
    await RequestREAD.get(`${path}/GetAutoCompleteRelacoes`, { params })

  const getRelacoesById = async (id: number): Promise<AxiosResponse<IUnidadeGestoraRelacoes>> =>
    await RequestREAD.get(`${path}/GetRelacoesById/${id}`)

  const newAutoComplete = async (params: { tpUnidade: string, name: string }): Promise<AxiosResponse<any>> =>
    await RequestREAD.get(`${path}/NewAutoComplete/${params.tpUnidade}/${params.name}`)

  return {
    newAutoComplete,
    autoComplete,
    getAll,
    getById,
    getByName,
    getRelacoesById
  }
}

//
export interface INewAutoCompleteRelacao {
  idUnidadeGestora: number;
  nmUnidade: string;
  sgUnidade: string;
  nmTipoUnidade: NmTipoUnidade;
  idUnidadePai: number | null;
  numeroUnidade: string;
  pais: INewAutoCompleteRelacao[] | null;
  filhos: INewAutoCompleteRelacao[];
}

export enum NmTipoUnidade {
  Diretoria = "Diretoria",
  DiretoriaExecutiva = "DiretoriaExecutiva",
  Gerencia = "Gerencia",
  GerenciaGeral = "GerenciaGeral",
}
//

export interface Relacao {
  idUnidadeGestora: number
  nmUnidade: string
  sgUnidade: string
  numeroUnidade: string
  nmTipoUnidade:
  | 'DiretoriaExecutiva'
  | 'Diretoria'
  | 'GerenciaGeral'
  | 'Gerencia'
  idUnidadePai: number
}

export interface IUnidadeGestoraResponse {
  idUnidadeGestora: number
  nmUnidade: string
  sgUnidade: string
  numeroUnidade: string
  nmTipoUnidade:
  | 'DiretoriaExecutiva'
  | 'Diretoria'
  | 'GerenciaGeral'
  | 'Gerencia'
  idUnidadePai?: number
  relacoes: Relacao[]
}

export interface IUnidadeGestoraRelacoes {
  idUnidadeGestora: number
  nmUnidade: string
  sgUnidade: string
  numeroUnidade: string
  nmTipoUnidade:
  | 'DiretoriaExecutiva'
  | 'Diretoria'
  | 'GerenciaGeral'
  | 'Gerencia'
  idUnidadePai?: number
  pai: IUnidadeGestoraRelacoes[]
  filhos: IUnidadeGestoraRelacoes[]
  netos: IUnidadeGestoraRelacoes[]
}
